export default "__VITE_ASSET__DNmNKL7p__"